import * as React from 'react';
// @ts-ignore
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { useTranslation } from 'react-i18next';
import { parse } from 'url';
import { push } from 'connected-react-router';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import type { Props } from '@unitedtraders/conversion-microfrontend';
import { KeycloakContext } from 'init/App';
import { useConfig } from '../../hooks/config';

export const Conversion: React.FC = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const keycloak = React.useContext(KeycloakContext)!;

  const config = useConfig();

  const { pathname } = useLocation();

  const [, baseUrl, homeUrl] = pathname.match(/^((.*)\/conversion)/)!;

  const dispatch = useDispatch();

  const appConfig: Props['appConfig'] = {
    keycloak: config.keycloak,
    graphqlGateway: config.graphqlGateway,
    utcomGateway: {
      rest: {
        url: parse(config.grpcGateway.url),
      },
    },
  };

  const props: Props = {
    locale: language,
    getTokens: () => keycloak.getTokens(),
    appConfig,
    basename: baseUrl,
    closeModal: () => dispatch(push(homeUrl)),
    goToInvestment: () => (window.location.href = '/investments'),
  };

  return (
    <Parcel
      config={() => import('@unitedtraders/conversion-microfrontend')}
      mountParcel={mountRootParcel}
      {...props}
    />
  );
};
